var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'ml-3 font-weight-bold',
    _vm.contract.isBlocked
      ? 'error--text'
      : _vm.contract.isActive
      ? 'success--text'
      : 'grey--text' ]},[_vm._v(" "+_vm._s(_vm.contract.isRemoved ? _vm.$t("tsmarket.status.contract-status-removed") : _vm.contract.isBlocked ? _vm.$t("tsmarket.status.contract-status-blocked") : _vm.contract.isActive ? _vm.$t("tsmarket.status.contract-status-switch-on") : _vm.$t("tsmarket.status.contract-status-switch-off"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }